import { useState, useEffect, useCallback, useMemo, createContext, useContext } from "react";
import axios from "axios";
import { API } from "../config/constants";
import { adminAxios } from "../config/adminAxios";

const ProductContext = createContext(null);

export function ProductProvider({ children }) {
  const [products, setProducts] = useState([]);

  const fetchProducts = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/products`);
      setProducts(res.data);
    } catch (error) {
      console.warn("Failed to fetch products:", error.message);
    }
  }, []);

  const deleteProduct = useCallback(async (productId) => {
    try {
      await adminAxios.delete(`/products/${productId}`);
      fetchProducts();
      return true;
    } catch (error) {
      console.warn("Failed to delete product:", error.message);
      return false;
    }
  }, [fetchProducts]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  const value = useMemo(() => ({ products, fetchProducts, deleteProduct }), [products, fetchProducts, deleteProduct]);

  return (
    <ProductContext.Provider value={value}>
      {children}
    </ProductContext.Provider>
  );
}

export function useProducts() {
  return useContext(ProductContext);
}
